/* PRODUCT 01 · Galleries
   Premium client gallery experience. */
import React from "react";
import ProductPageLayout from "./ProductPageTemplate";
import { EDITORIAL_ASSETS } from "@/lib/editorialAssets";

export default function GalleriesPage() {
  return (
    <ProductPageLayout
      chapter="01"
      label="Galleries"
      headline={<>Galleries that feel like a private <em>viewing</em>.</>}
      descriptor="Bespoke delivery that elevates your work. A quiet room for the client — selections, favorites, downloads, slideshows, and an optional musical underscore."
      features={["LIGHTBOX","SELECTIONS","DOWNLOADS","MUSIC SLOT","SLIDESHOW"]}
      primaryCta={{ label: "Open a live gallery \u2192", href: "/gallery/spring-editorial-2026" }}
      secondaryCta={{ label: "Pricing \u2192", href: "/marketing#pricing" }}
      previewItems={[
        { label: "EDITORIAL TEMPLATE", image: EDITORIAL_ASSETS.editorial_studio_wide.src,    alt: EDITORIAL_ASSETS.editorial_studio_wide.alt },
        { label: "MOSAIC TEMPLATE",    image: EDITORIAL_ASSETS.editorial_couple_warm.src,    alt: EDITORIAL_ASSETS.editorial_couple_warm.alt },
        { label: "CINEMA TEMPLATE",    image: EDITORIAL_ASSETS.editorial_back_pose.src,      alt: EDITORIAL_ASSETS.editorial_back_pose.alt },
      ]}
    />
  );
}
